import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get} from '../modules/user';
import { showErrors } from '../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const userId = _.get(ownProps, ['match', 'params', 'userId']);
	const user = (userId) ? _.get(state.maps, ['user', userId]) : undefined;
	return {
		user,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	addUser : add,
	updateUser : update,
	getUser : get,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
